const MoneyBagCoin = () => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M7.39076 3.66668L4.60957 3.66668L3.67551 2.59532C2.75989 1.54509 3.82806 -0.0246724 5.16488 0.406575L5.78339 0.606104C5.92421 0.651532 6.07611 0.651532 6.21694 0.606104L6.83545 0.406576C8.17226 -0.024672 9.24044 1.5451 8.32481 2.59532L7.39076 3.66668Z"
        fill="#6B50FF"
      />
      <path
        opacity="0.4"
        d="M1.78969 5.8069C2.31153 4.137 3.85807 3 5.60761 3H6.39275C8.14229 3 9.68882 4.137 10.2107 5.8069L11.044 8.47357C11.8489 11.0493 9.92464 13.6667 7.22608 13.6667H4.77427C2.07571 13.6667 0.15144 11.0493 0.956353 8.47357L1.78969 5.8069Z"
        fill="#6B50FF"
      />
      <path
        d="M6 12.3333C6 11.597 6.59695 11 7.33333 11H11.3333C12.0697 11 12.6667 11.597 12.6667 12.3333C12.6667 13.0697 12.0697 13.6667 11.3333 13.6667H7.33333C6.59695 13.6667 6 13.0697 6 12.3333Z"
        fill="#6B50FF"
      />
      <path
        d="M6 9.66668C6 8.9303 6.59695 8.33334 7.33333 8.33334H10.8889H11.3333C12.0697 8.33334 12.6667 8.9303 12.6667 9.66668C12.6667 10.4031 12.0697 11 11.3333 11H7.33333C6.59695 11 6 10.4031 6 9.66668Z"
        fill="#6B50FF"
      />
    </svg>
  );
};

export default MoneyBagCoin;
